module.exports = __webpack_public_path__ + "img/err-network-2segments.2e248e1f.svg";